<template>
  <div>
    <!-- Feature Area Starts -->
    <div class="about-bottom_img" style="position: relative;">
      <img style="width:100%;height:50vh" v-if="solutionlist.position1.length>0" :src="solutionlist.position1[0].thumb" />
      <p v-if="false" style="position: absolute;
              color: #fff;
              bottom: 10vh;
              font-size: 6vh;
              left: 12%;
              border-bottom: 2px solid #ccc;
              font-weight: 600;">{{ solutionlist.position1[0].title }}</p>
    </div>
    <section class="banner-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6  offset-xl-1 align-self-center">
            <div class="banner-about color-about">
              <h2 class="color-about" style="font-size: 2.5vh;" v-if="solutionlist.position2.length>0" >{{ solutionlist.position2[0].title }}</h2>
              <b class="slot-about"></b>
              <p class="py-3" style="text-indent:2em;" v-if="solutionlist.position2.length>0" >{{ solutionlist.position2[0].brief }}</p>
              <!-- <a href="#" class="secondary-btn color-about">点击了解<span class="flaticon-next"></span></a> -->
            </div>
          </div>
          <div class="col-lg-5 px-0" style="padding:1px">
            <!-- <div class="banner-bg"></div> -->
            <img v-if="solutionlist.position2.length>1" :src="solutionlist.position2[1].thumb" alt="" style="width: 100%; height: 40vh;">
          </div>
          <div class="col-lg-11  offset-xl-1">
            <div class="foot-banner"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="feature-area section-padding2">
      <div class="container">
        <div class="row" v-if="solutionlist.position3.length>0">
          <div class="col-lg-12">
            <div class="section-top text-center ">
              <h4 class="color-about"> {{ solutionlist.position3[0].title }}</h4>
              <p class="py-3 text-left color-about" style="font-style: unset; text-indent: 2em;">{{ solutionlist.position3[0].brief }}
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div v-if="solutionlist.position3.length>1" class="single-feature mb-4 mb-lg-0 "
              :style="{ backgroundImage: 'url(' + solutionlist.position3[1].thumb + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'cover', height: '20vh' }">

              <h4 class="color-about-foot">{{ solutionlist.position3[1].title }}</h4>
              <p class="py-0 color-about-foot">{{ solutionlist.position3[1].brief }}</p>
              <!-- <a href="#" class="secondary-btn" >联系我们<span class="flaticon-next"></span></a> -->
            </div>
          </div>
          <div class="col-lg-4">
            <!-- single-feature 动画 -->
            <div v-if="solutionlist.position3.length>2" class="single-feature mb-4 mb-lg-4"
              :style="{ backgroundImage: 'url(' + solutionlist.position3[2].thumb + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'cover', height: '20vh' }">
              <h4 class="color-about-foot">{{ solutionlist.position3[2].title }}</h4>
              <p class="py-0 color-about-foot">{{ solutionlist.position3[2].brief }}</p>
              <!-- <a href="#" class="secondary-btn" >联系我们<span class="flaticon-next"></span></a> -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4" v-if="solutionlist.position3.length>3"  >
            <div class="single-feature mb-4 mb-lg-4"
              :style="{ backgroundImage: 'url(' + solutionlist.position3[3].thumb + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'cover', height: '20vh' }">
              <h4 class="color-about-foot">{{ solutionlist.position3[3].title }}</h4>
              <p class="py-0 color-about-foot">{{ solutionlist.position3[3].brief }}</p>
              <!-- <a href="#" class="secondary-btn" >联系我们<span class="flaticon-next"></span></a> -->
            </div>
          </div>
          <div class="col-lg-4" v-if="solutionlist.position3.length>4" >
            <div class="single-feature mb-4 mb-lg-4"
              :style="{ backgroundImage: 'url(' + solutionlist.position3[4].thumb + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'cover', height: '20vh' }">
              <h4 class="color-about-foot">{{ solutionlist.position3[4].title }}</h4>
              <p class="py-0 color-about-foot">{{ solutionlist.position3[4].brief }}</p>
              <!-- <a href="#" class="secondary-btn" >联系我们<span class="flaticon-next"></span></a> -->
            </div>
          </div>
          <div class="col-lg-4" v-if="solutionlist.position3.length>5" >
            <div class="single-feature mb-4 mb-lg-4"
              :style="{ backgroundImage: 'url(' + solutionlist.position3[5].thumb + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'cover', height: '20vh' }">
              <h4 class="color-about-foot">{{ solutionlist.position3[5].title }}</h4>
              <p class="py-0 color-about-foot">{{ solutionlist.position3[5].brief }}</p>
              <!-- <a href="#" class="secondary-btn" >联系我们<span class="flaticon-next"></span></a> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Area End -->
  </div>
</template>

<script>
import { us } from '@/api/index'
import axios from "axios";

export default {
  data() {
    return {
      solutionlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: [],
      },
    }
  },
  mounted() {
    this.getus(this.$route.query.id)
  },
  methods: {
    getus(id) {
      axios.get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(res => {
        let list = res.data.data;
        for (let index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            this.solutionlist.position1.push(list[index])
          } else if (list[index].position == 2) {
            this.solutionlist.position2.push(list[index])

          } else if (list[index].position == 3) {
            list[index].status1 = false
            this.solutionlist.position3.push(list[index])

          } else if (list[index].position == 4) {
            this.solutionlist.position4.push(list[index])
          }
        }
      })
    },
  },
}
</script>
<style scoped>
@media (min-width: 280px) {
  .col-lg-11 {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .about-bottom_img {
    /* height: 50vh;
    background:url(/static/assets/images/guanyuwmen.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */
  }
}

@media (min-width: 1200px) {
  .section-top {
    margin-bottom: 0px !important;
  }

  .about-bottom_img {
    height: 50vh;
    /* background:url(/static/assets/images/guanyuwmen.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */
  }
}

.btn-about {
  background: #FFFFFF;
}

.banner-about {
  padding: 0 10% 0 5%;
}

.color-about {
  color: #43577B;
}

.color-about-foot {
  color: #FFFFFF;
}

.single-feature {
  padding: 40px;
}

.chengshi1 {
  background: url('/static/assets/images/banner-bg.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.py-4 {
  padding-bottom: 2rem !important;
  padding-top: 0rem !important
}

.section-padding2 {
  /* padding-bottom: 50px; */
}

.slot-about {
  width: 2.6rem;
  height: 0.4rem;
  display: block;
  overflow: hidden;
  background-color: #43577B;
  left: 0px;
  bottom: 0px;
  top: 45px;
}

.foot-banner {
  width: 100%;
  position: absolute;
  height: 40px;
  background-color: #43577B;
}
</style>



// WEBPACK FOOTER //
// About.vue?4e66500b